import React from "react";
import {Helmet} from "react-helmet";
import { Link } from "react-router-dom";
import Header from '../header';
import Footer from '../footer';
import './projects.css';
import Carousel from '../carousel';
import Fujairah1 from '../../images/New_Pro_imgs/fujairah_2.jpeg';
import Fujairah2 from '../../images/New_Pro_imgs/fujairah_build.jpeg';
import Fujairah3 from '../../images/fujairah-cultural-project3.webp';
import Fujairah4 from '../../images/fujairah-cultural-project4.webp';
import Fujairah5 from '../../images/fujairah-cultural-project5.webp';
function fujairah() {
  return (
    
    <>
    <div className="boxed_wrapper" id="project">
    <Helmet>
        <title>Fujairah Auditorium - Moov Group</title>
        <meta name="description" content=""/>
        <meta property="og:title" content="Fujairah Auditorium" />
        <meta property="og:description" content=""/>
        <meta property="og:image" content="../../images/moovgroup-office.webp" />
        <link rel="canonical" href="https://www.moovgroup.com/fujairah-auditorium-acoustics" />
        <link rel="alternate" href="https://www.moovgroup.com/fujairah-auditorium-acoustics" hreflang="en-GB" />
    </Helmet>
    <Header />
    <div id="moov">
    <section className="breadcrumb-section projects-bg">
        <div className="container">
            <h1 className="page-title">Fujairah Cultural Center Auditorium</h1>
            <span className="page-tag">Acoustic Design, Supply and Installation, Acoustic Treatment on Wall and Ceiling, Supply and Installation of Seating</span>
        </div>
    </section>
    
    <section className="portfolio-section section-gap-top" id="portfolio">
        <div className="container">
            
	            <div className="portfolio-items">
		            <div className="portfolio-item portfolio-style-four">
		                
			            <div className="row align-items-center">
				            <div className="col-lg-6 col-md-6">
				            <div className="portfolio-container1">
				                   <h1 className="portfolio-previous">AFRICA HALL</h1>
				            </div>
				            </div>
				            <div className="col-lg-6 col-md-6">
				                <div className="portfolio-container2">
				                    <Link to="/africa-hall-acoustics" className="portfolio-next">Next &raquo;</Link>
				                </div>
                            </div>
                        </div>
                        <span className="line-footer"></span>
                    </div>
                </div>
                
            <div className="row portfolio-items portfolio-filter" id="portsub"  style={{position: "relative", height: "580px"}}>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design web" style={{position: "absolute", right: "0px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Fujairah1} alt="Fujairah Auditorium Acoustics - 1" style={{ height: "280px" }} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Fujairah</span>
                            <h5 className="title"><Link to="/fujairah-auditorium-acoustics">Cultural Center</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 filter-item game" style={{position: "absolute", right: "295px", bottom: "0px"}}>
                    <div className="portfolio-item big-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Fujairah2} alt="Fujairah Auditorium Acoustics - 2"  />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Fujairah</span>
                            <h5 className="title"><Link to="/fujairah-auditorium-acoustics">Cultural Center</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item web" style={{position: "absolute", right: "885px", bottom: "0px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Fujairah3} alt="Fujairah Auditorium Acoustics - 3" style={{ height: "280px" }} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Fujairah</span>
                            <h5 className="title"><Link to="/fujairah-auditorium-acoustics">Cultural Center</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item design" style={{position: "absolute", right: "0px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Fujairah4} alt="Fujairah Auditorium Acoustics - 4" style={{ height: "280px" }} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Fujairah</span>
                            <h5 className="title"><Link to="/fujairah-auditorium-acoustics">Cultural Center</Link></h5>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6 filter-item game web" style={{position: "absolute", right: "885px", bottom: "290px"}}>
                    <div className="portfolio-item">
                        <div className="portfolio-thumb">
                            <div className="thumb">
                                <img src={Fujairah5} alt="Fujairah Auditorium Acoustics - 5" style={{ height: "280px" }} />
                            </div>
                        </div>
                        <div className="portfolio-desc">
                            <span className="cat">Fujairah</span>
                            <h5 className="title"><Link to="/fujairah-auditorium-acoustics">Cultural Center</Link></h5>
                   
				        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section className="recently-project-style2-area">
            <div className="container">
                <div className="sec-title text-center">
                    <div className="pro-title">Our Projects</div>
                    <p className="bottom-text">we have successfully completed more than 900 acoustic projects<br /> over the last 17 years across the Middle East.<br /> Have a glance at our recently compeleted projects</p>
                </div>
                <Carousel />
            </div>
        </section>
        </div>
    </div>
<Footer />
</>
  );
}

export default fujairah;